import { ToastStateHandler } from '../../api';

export class BranchHandler {
    constructor(private readonly toastHandler: ToastStateHandler, private readonly languageData: any) {}

    public branchCreationFailed(): void {
        this.toastHandler.push(
            'error',
            this.languageData.branches.wsNotifications.BRANCH_DELETION_FAILED_TITLE,
            this.languageData.branches.wsNotifications.BRANCH_DELETION_FAILED_MESSAGE
        );
    }
}
